module.exports = __webpack_public_path__ + "static/img/image4.bc45f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instruction_images/image4.png
// module id = nRYp
// module chunks = 0